import { Button } from 'components/button/Button'
import { useDashboardSideModal } from 'components/content/dashboardSideModal/utils'
import { SectionEmptyState } from 'components/sectionEmptyState/SectionEmptyState'
import { handleAndToastError } from 'components/Toast'
import { createDirectiveAndRedirect } from 'logic/directive/create/create'
import { useLoadingCallback } from 'utils/hooks'

export const DirectiveListEmptyState = ({
  title,
  description,
}: {
  title: string
  description: string
}) => {
  const [onCreate, isCreating] = useLoadingCallback(async () => {
    await createDirectiveAndRedirect('WILL', {
      isLogged: true,
      fromInside: true,
      routerMechanism: 'push',
    }).catch(handleAndToastError)
  })

  const [infoModal, openInfoModal] = useDashboardSideModal('ESTATE_PLANNING')

  return (
    <>
      {infoModal}
      <SectionEmptyState
        icon="Will"
        title={title}
        description={description}
        buttons={
          <>
            <Button type="button" variant="secondary" onClick={openInfoModal}>
              Learn More
            </Button>
            <Button onClick={onCreate} loading={isCreating} type="button">
              Create Will
            </Button>
          </>
        }
      />
    </>
  )
}
